import { createStandardAction, createAsyncAction } from 'typesafe-actions'
import { GetHistoryActivityReq, GetHistoryActivityApi } from './types'

export const getHistoryActivityAction = createAsyncAction(
  'maincon/report/FETCH_ACTIVITY_REQUEST',
  'maincon/report/FETCH_ACTIVITY_SUCCESS',
  'maincon/report/FETCH_ACTIVITY_FAILURE'
)<GetHistoryActivityReq, GetHistoryActivityApi, any>()
